import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import ContainerModal from 'components/Modal';
import SimpleInput from 'components/SimpleInput';
import PhotoMyAccount from 'components/PhotoMyAccount';
import { getObjOnLocalStorage } from 'utils/functions';
import { UserMyAccountProps } from 'types/UserMyAccountProps';

import MyAccountContext from 'context/MyAccountContext';

export default function MyAccount() {
	const { t }: UseTranslationProps = useTranslation();
	const { isOpen, setIsOpen } = useContext(MyAccountContext);

	const [userDataFromLocalStorage, setUserDataFromLocalStorage] =
		useState<UserMyAccountProps>();

	const [newImage, setNewImage] = useState<any>('');
	const [newName, setNewName] = useState<string>('');
	const [newEmail, setNewEmail] = useState<string>('');
	const [newPassWord, setNewPassword] = useState<string>('');

	async function saveUser() {
		setIsOpen(false);
	}

	useEffect(() => {
		setUserDataFromLocalStorage(getObjOnLocalStorage());
	}, []);

	useEffect(() => {
		if (
			userDataFromLocalStorage !== undefined &&
			userDataFromLocalStorage !== null
		) {
			setNewImage(userDataFromLocalStorage.Image || '');
			setNewName(userDataFromLocalStorage.Name || 'Escreva seu nome');
			setNewEmail(userDataFromLocalStorage.Email || '');
		}
	}, [userDataFromLocalStorage]);

	return (
		<div>
			<ContainerModal
				title={t('myAccount.title')}
				isOpenProps={isOpen}
				setIsOpenModal={() => {
					setIsOpen((value) => !value);
				}}
				buttonClose={false}
			>
				<S.container>
					<S.containerPhoto>
						<PhotoMyAccount getImage={setNewImage} imageProps={newImage} />
					</S.containerPhoto>

					<SimpleInput
						label={t('myAccount.name')}
						getValue={setNewName}
						initialValue={newName}
					/>
					<SimpleInput
						label={t('myAccount.email')}
						getValue={setNewEmail}
						initialValue={newEmail}
						typeInput="email"
					/>
					<SimpleInput
						label={t('myAccount.password')}
						getValue={setNewPassword}
						initialValue={newPassWord}
						typeInput="password"
					/>
					<S.noticePassword>
						{newPassWord === '' && <p>*{t('myAccount.noticePassword')}.</p>}
					</S.noticePassword>
					<S.containerBtns>
						<S.cancel onClick={() => setIsOpen(false)}>
							{t('myAccount.btnCancel')}
						</S.cancel>
						<S.save onClick={() => saveUser()}>{t('myAccount.btnSave')}</S.save>
					</S.containerBtns>
				</S.container>
			</ContainerModal>
		</div>
	);
}
